import styles from 'views/widgets/DeleteButton/DeleteButton.css';
import React from 'react';
import classnames from 'classnames';
import config from 'config/config_server.json';
import IconButton from 'views/widgets/IconButton';

let deleteButton = `${config.editorUrl}/deleteButton.svg`;

const CheckBox = ({className, ...props}) => (
  <div className={classnames(styles.delete, {[className]: className})}>
    <IconButton
      {...props}>
      <img className={styles.deleteButton} src={deleteButton} alt='Delete Event'/>
    </IconButton>
  </div>
);

export default CheckBox;



/** WEBPACK FOOTER **
 ** ./src/views/widgets/DeleteButton/DeleteButton.js
 **/